module.exports = __webpack_public_path__ + "static/media/RBG_art_Kuu_Chen.e7f2364c.png";